import React, { useEffect, useState }  from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import { ThemeProvider, useTheme, makeStyles } from '@mui/styles';
import TableChartIcon from '@mui/icons-material/TableChart';
import Divider from '@mui/material/Divider';

import {header_exp_config, header_files_config, header_qc_metrics_config} from "./headers_config";
import { GPAP_Button_light } from '../../../../gpap-lib/Button_Collection';


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: "100%",
        maxHeight: "300px",
        overflowY: "auto",
        backgroundColor: 'background.paper',
    },
    formControl: {
        margin: "30px",
        width: "30%"
    },
}));




const CustomizeColumns = (props) => {

    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [checked, setChecked] = useState([]);
    const [columns, setColumns] = useState([]);

    useEffect(() => {
        // Initialization
        let headers = [];
        if(props.type === "exp"){
            headers = [...header_exp_config];
        }
        else if(props.type === "files"){
            headers = [...header_files_config];
        }
        else if(props.type === "metrics"){
            headers = [...header_qc_metrics_config];
        }
        setChecked(headers.map(x => x.key));
        setColumns(headers.map(x => x.key));
    },[])

    const handleCheck = (value) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const selectAll = (bool) => {
        if(bool){
            setChecked(columns);
        }
        else{
            setChecked([]);
        }
    };

    const handleUpdate = () => {
        setOpen(false);
        let columns_view = [];
        columns.forEach(item => {
            if(checked.indexOf(item) !== -1){
                columns_view.push(item)
            }
        });
        props.updateColumns(columns_view);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <React.Fragment>
            <GPAP_Button_light color="primary" onClick={handleClickOpen} startIcon={<TableChartIcon/>}>
               Select Table Columns
            </GPAP_Button_light>

            <Dialog
                fullWidth={true}
                maxWidth={"sm"}
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{"Select Table Columns"}</DialogTitle>
                <DialogContent>
                    <Typography variant={"subtitle1"}> Select Columns</Typography>
                    <Typography variant={"subtitle2"}>The selection doesn't apply to the download</Typography>
                    <Divider/>
                    <Button onClick={() => selectAll(true)} color="primary" >
                        Select All
                    </Button>
                    <Button onClick={() => selectAll(false)} color="primary" >
                        Deselect All
                    </Button>
                    <Divider/>
                    <List className={classes.root}>
                        {columns.map((item, index) => {
                            const labelId = item;
                            const checked_bool = checked.indexOf(item) !== -1;
                            return (
                                <ListItem key={index} role={undefined} dense button onClick={handleCheck(item)}>
                                    <ListItemIcon>
                                        <Checkbox
                                            edge="start"
                                            checked={checked_bool}
                                            tabIndex={-1}
                                            disableRipple
                                            inputProps={{ 'aria-labelledby': labelId }}
                                        />
                                    </ListItemIcon>
                                    <ListItemText id={labelId} primary={labelId} />
                                </ListItem>
                            );
                        })}
                    </List>

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Not now
                    </Button>
                    <Button onClick={handleUpdate} color="primary" >
                        Update Table
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}


export default CustomizeColumns;